import { loginUrlFor } from "./utils/authRedirect";

const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:8000";

export function authFetch(url, options = {}) {
  const token = localStorage.getItem("token");
  return fetch(`${API_BASE}${url}`, {
    ...options,
    headers: {
      ...options.headers,
      Authorization: token ? `Bearer ${token}` : "",
      "Content-Type": "application/json",
    },
  }).then(async (res) => {
    if (res.status === 401) {
      // Token invalid/expired. This is the common case for a link opened from an email hours
      // later: PrivateRoute waves you through (it only checks the token EXISTS), the page
      // renders, then this fires — so the deep path has to be carried over to login or the
      // listing the reader clicked is lost.
      window.location.href = loginUrlFor();
      return Promise.reject("Unauthorized");
    }
    return res.json();
  });
}

export const fetchPrediction = async (propertyId) => {
  const data = await authFetch(`/predict/sale/${propertyId}`);
  console.log("fetchPrediction",data);
  return data;
};
